import { Validators } from '@angular/forms';

import { ComponentTypesEnum } from '../../../app/shared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from '../../../app/shared/components';
import { AmountControl, BaseControl, SelectControl } from '../../../app/shared/classes';

import { EnumsHelper } from 'appShared/classes/common/helpers';
import {CurrencyTypesEnum} from '@spa/api';
import {WithdrawalAmountSelector} from 'appAssets/descriptors';

export const AdjustmentAccountSelector = 'adjustmentAccount';
export const AdjustmentAmountSelector = 'adjustmentAmount';
export const AdjustmentCategorySelector = 'adjustmentCategory';
export const AdjustmentCommentSelector = 'adjustmentComment';
export const AdjustmentCurrencySelector = 'adjustmentCurrency';
export interface SingleAdjustmentControlsnterface {
    amount: AmountControl;
    category: SelectControl;
    comment: BaseControl;
    currencies: SelectControl;
}

export const AdjustmentComponentControls = (): SingleAdjustmentControlsnterface => {
    const controls = {
        amount: new AmountControl({
            name: AdjustmentAmountSelector,
            value: null,
            placeholder: 'Amount',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            fourDecimals: true,
            currency: ''
        }),
        category: new SelectControl({
            name: AdjustmentCategorySelector,
            value: null,
            placeholder: 'Category',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: EnumsHelper.getAdjustmentCategoryOptions()
        }),
        comment: new BaseControl({
            name: AdjustmentCommentSelector,
            value: null,
            placeholder: 'Comment',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            readonly: false
        }),
        currencies: new SelectControl({
            name: AdjustmentCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [{
                    value: CurrencyTypesEnum.Usd,
                    label: CurrencyTypesEnum.Usd,
                },
                {
                    value: CurrencyTypesEnum.Euro,
                    label: CurrencyTypesEnum.Euro,
                }]
        }),
    };

    return controls;
};

export const AdjustmentDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
